import request from '@/utils/request'


export function synchronizedLogistics() {
  return request({
    url: '/order/sell/synchronizedLogistics',
    method: 'get'
  })
}
// 查询销售订单列表
export function listSell(query) {
  return request({
    url: '/order/sell/list',
    method: 'get',
    params: query
  })
}

// 查询销售订单分页
export function pageSell(query) {
  return request({
    url: '/order/sell/page',
    method: 'get',
    params: query
  })
}
export function pageOffline(query) {
  return request({
    url: '/order/sell/pageOffline',
    method: 'get',
    params: query
  })
}
// 查询销售订单详细
export function getSell(data) {
  return request({
    url: '/order/sell/detail',
    method: 'get',
    params: data
  })
}
export function retrySendOrder(id) {
  return request({
    url: '/order/sell/retrySendOrder/' + id,
    method: 'get'
  })
}
// 查询销售订单详细
export function getSellOffline(data) {
  return request({
    url: '/order/sell/detailOffline',
    method: 'get',
    params: data
  })
}



export function getLogisticsById(data) {
  return request({
    url: '/order/delivery/getLogisticsById',
    method: 'post',
    data: data
  })
}


export function cancelSell(data) {
  return request({
    url: '/order/sell/cancel',
    method: 'post',
    data: data
  })
}


export function updateDelivery(data) {
  return request({
    url: '/order/sell/updateDelivery',
    method: 'post',
    data: data
  })
}
// 修改金额
export function updatePriceApi(data) {
  return request({
    url: '/order/sell/modifyPrice',
    method: 'post',
    data: data
  })
}


export function writeOffSell(data) {
  return request({
    url: '/order/sell/WriteOff',
    method: 'post',
    data: data
  })
}

export function ordersSell(data) {
  return request({
    url: '/order/sell/orders',
    method: 'post',
    data: data
  })
}

export function deliverySell (data) {
  return request({
    url: '/order/sell/delivery',
    method: 'post',
    data: data
  })
}
export function orderDeliveryUpdate (data) {
  return request({
    url: '/order/sell/orderDeliveryUpdate',
    method: 'post',
    data: data
  })
}
// 导入待发货(后端执行较慢, 单独放宽超时, 避免请求超时)
export function importData (data) {
  return request({
    url: '/order/sell/delivery/import',
    method: 'post',
    data: data,
    timeout: 600000 // 单位ms, 10分钟
  })
}

//物流信息
export function logistics(data) {
  return request({
    url: '/order/sell/logistics',
    method: 'get',
    params: data
  })
}

// 查询待审批金额修改订单 列表
export function pendingModifyPricePage(query) {
  return request({
    url: '/order/sell/pendingModifyPricePage',
    method: 'get',
    params: query
  })
}

// 审批订单金额修改
export function approveModifyPrice(data) {
  return request({
    url: '/order/sell/approveModifyPrice',
    method: 'post',
    data: data
  })
}
